import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilService } from '../../../../service/util.service';
import { NavController, ToastController } from '@ionic/angular';
import { ReportService } from '../../report.service';
import { UserProfile } from '../../../../models/user-profile.model';
import * as XLSX from 'xlsx';
import { NavigationExtras } from '@angular/router';
import { AES } from 'crypto-js';
import { environment } from '../../../../../environments/environment';
import { Storage } from '@ionic/storage';
import { IonicSelectableComponent } from 'ionic-selectable';

@Component({
  selector: 'app-report-proposal',
  templateUrl: './report-proposal.page.html',
  styleUrls: ['./report-proposal.page.scss'],
})
export class ReportProposalPage implements OnInit {
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;

  reportData:any=[];
  token: any;
  userProfile: UserProfile = new UserProfile();
  userAccess: any[] = [];
      
  paramProposalNumber: any = null;
  paramCounterId:any;
  paramWarehouseId: any;
  paramPeriodStart: any = null;
  paramPeriodEnd: any = null;
  selectedCounters: any[] = [];

  counterData: any[] = [];

  filter = {
      period_start: null,
      period_end: null
  };
  constructor(
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private reportService: ReportService,
    private navCtrl: NavController,
    private storage: Storage,
  ) { }

  ngOnInit() {
     Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userAccess = access;
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.userProfile = new UserProfile(profile);
          let counterId = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
         
          let options = { 
            "token": this.token,
            "counter_id": counterId
          };
          this.reportService.getReportProposalIndex(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.counterData = response.results.counter_data;
            let todayDate = new Date();
            let convertDateStart = this.paramPeriodStart ? this.utilService.convertDate(this.paramPeriodStart) : this.utilService.convertDate(todayDate);
            
            let convertDateEnd = this.paramPeriodEnd ? this.utilService.convertDate(this.paramPeriodEnd) : this.utilService.convertDate(todayDate);
            let startDate = convertDateStart.years + '-' + convertDateStart.months + '-' + convertDateStart.dates;
            let endDate = convertDateEnd.years + '-' + convertDateEnd.months + '-' + convertDateEnd.dates;
            this.filter.period_start = startDate;
            this.filter.period_end = endDate;
            this.generateReport();
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  generateReport() {
    var counterIds = [];
    if (
        this.selectedCounters &&
        this.selectedCounters.length > 0
    ) {
        for (
            var i = 0;
            i < this.selectedCounters.length;
            i++
        ) {
            counterIds.push(
                this.selectedCounters[i].id
            );
        }
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "proposal_number": this.paramProposalNumber,
        "counter_id": counterIds,
        "period_start":this.filter.period_start,
        "period_end": this.filter.period_end
      };
      this.reportService.getProposalReport(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.reportData = response.report_data;
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  exportExcel() {
    if (!this.reportData || this.reportData.length === 0) {
      return;
    }
    const excelData = this.reportData.map(
      (report: any, index: number) => {
        return {
          'No': index + 1,
          'Proposal Number': report.proposal_number,
          'Start Date': report.proposal_start_date,
          'End Date': report.proposal_end_date,
          'Total Qty': Number(report.total_qty),
          'Fulfilled Qty': Number(report.fulfilled_qty),
          'Remaining Qty': Number(report.remaining_qty),
          'Fulfillment Percentage':
            Number(report.fulfillment_percentage) / 100,
          'Status': report.status_proposal
        };
      }
    );
    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(excelData);
    // Format percentage
    const percentageColumn =
      XLSX.utils.decode_col('H');
    for (
      let row = 2;
      row <= excelData.length + 1;
      row++
    ) {
      const cellAddress =
        XLSX.utils.encode_cell({
          r: row - 1,
          c: percentageColumn
        });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].z = '0.00%';
      }
    }
    // Lebar kolom
    worksheet['!cols'] = [
      { wch: 6 },
      { wch: 25 },
      { wch: 15 },
      { wch: 15 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
      { wch: 23 },
      { wch: 15 }
    ];
    const workbook: XLSX.WorkBook =
      XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Proposal Report'
    );
    XLSX.writeFile(
      workbook,
      'Proposal_Report.xlsx'
    );
  }
  openDetail(report: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(report.proposal_number),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID
      }
    };
    this.navCtrl.navigateForward(['/report-proposal/report-proposal-detail'], navigationExtras);
  }

  selectAllCounters() {
      this.selectedCounters = this.counterData.slice();
  }

  deselectAllCounters() {
      this.selectedCounters = [];
  }

  toggleAllCounters() {
      if (this.selectedCounters.length === this.counterData.length) {
          this.selectedCounters = [];
      } else {
          this.selectedCounters = this.counterData.slice();
      }
  }
}
